import {
  jb_language_list_css_default
} from "./chunk.3UAL5I4P.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-language-list/jb-language-list.ts
var JbLanguageList = class extends i {
  _getLabel(labelText) {
    const trimmed = labelText.trim().toLowerCase();
    return trimmed.endsWith(":") ? trimmed : `${trimmed}:`;
  }
  render() {
    const isSingle = this.languages.length === 1;
    return b`
      ${this.languageLabel ? b`<label part="label">${this._getLabel(this.languageLabel)}</label>` : A}
      <ul role="${isSingle ? "presentation" : A}">
        ${this.languages.map(
      (language) => b`<li role="${isSingle ? "presentation" : A}">
              <jb-anchor
                .text=${language.text}
                .link=${language.link}
                .ariaLabels=${language.ariaLabels}
                exportparts="anchor"
                >${language.text}</jb-anchor
              >
            </li>`
    )}
      </ul>
    `;
  }
};
JbLanguageList.styles = [reset_css_default, jb_language_list_css_default];
__decorateClass([
  n()
], JbLanguageList.prototype, "languageLabel", 2);
__decorateClass([
  n({ type: Array })
], JbLanguageList.prototype, "languages", 2);
JbLanguageList = __decorateClass([
  customElement("jb-language-list")
], JbLanguageList);

export {
  JbLanguageList
};
